export default "__VITE_ASSET__91a1a97d__"